import { apiClient } from './config';

/**
 * Register a new user
 */
export const registerUser = async (userData) => {
  const response = await apiClient.post('/auth/register', userData);
  return response.data;
};

/**
 * Login user with credentials
 */
export const loginUser = async (credentials) => {
  const response = await apiClient.post('/auth/login', credentials);
  return response.data;
};

/**
 * Get current authenticated user
 */
export const getCurrentUser = async () => {
  const response = await apiClient.get('/auth/me');
  return response.data;
};

/**
 * Change user password
 */
export const changePassword = async (passwordData) => {
  const response = await apiClient.post('/auth/change-password', passwordData);
  return response.data;
};
